import React from 'react'
import { connect } from 'react-redux'
import { ServiceType } from '../domain/ServiceType'
import { ApplicationState } from '../redux/ApplicationState'
import ExternalSnapshot from './external-snapshot'
import SnapshotComponent from './snapshot'

interface StateProps {
    parameters: { [key: string]: string }
}

type Props = StateProps

class RouteAwareSnapshotComponent extends React.Component<Props> {
    public render() {
        const serviceType = this.getServiceType()

        if (serviceType === ServiceType.external) {
            return <ExternalSnapshot />
        } else {
            return <SnapshotComponent />
        }
    }

    private getServiceType(): ServiceType {
        const serviceType = this.props.parameters.st

        if (serviceType !== ServiceType.php && serviceType !== ServiceType.external) {
            return ServiceType.php
        }

        return serviceType
    }
}

export default connect<StateProps, {}>((globalState: ApplicationState) => {
    return {
        parameters: globalState.tidewaysContext.route.parameters,
    }
})(RouteAwareSnapshotComponent)
